import { Component, Fragment, h, Prop, State } from '@stencil/core';
import { ShortArticle } from '../../../../types/types';
import ArrowDown from '../../svg-elements/arrow-down';
import { t } from '../../../../redux/utils';
import { ButtonSize, ButtonStyle } from '../../rentware-button/types';

@Component({
  tag: 'rtr-short-article-card',
  styleUrl: 'style.sass',
  shadow: false,
})
export class RtrShortArticleCard {
  @Prop() article: ShortArticle;
  @Prop() statusInfo: string | Node;
  @Prop() onStatusInfoAction: () => void;
  @Prop() onArticlesLoaded: () => void = () => {};
  @Prop() onClickForDetails: (articleId: string, scrollToCalendar?: boolean) => void;

  @State() articleWasVisible = false;

  cardContainer: HTMLDivElement;

  componentDidLoad() {
    this.onArticlesLoaded?.();

    let observer = new IntersectionObserver(this.handleVisible);
    observer.observe(this.cardContainer);
  }

  handleOpenDetails = () => {
    this.onClickForDetails(this.article.id);
  };

  handleVisible = entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !this.articleWasVisible) {
        this.articleWasVisible = true;
      }
    });
  };

  get detailsText() {
    return t('search.openDetails');
  }

  render() {
    return (
      <div ref={el => (this.cardContainer = el)} class="RSACContainer">
        {this.articleWasVisible && (
          <Fragment>
            <div class="RSACGallery">
              <rtr-gallery images={this.article.images} onImageClick={this.handleOpenDetails} />
            </div>
            <div class="RSACFooter">
              {this.article.isWaiting && <rentware-spinner withOverlay={true} />}

              <div onClick={this.handleOpenDetails} class="RSACInfoContainer">
                <div class="RSACInfo">
                  <span class="RSACName">{this.article.name}</span>
                  <span>{this.article.title}</span>
                </div>
                <div onClick={this.handleOpenDetails} class="RSACArrowSvg">
                  <ArrowDown />
                </div>
              </div>
              <div class="RSACButton">
                <span onClick={this.handleOpenDetails} class="RSACMore">
                  {this.detailsText}
                </span>
                  {!!this.onStatusInfoAction ?
                    (
                    <rentware-button appearance={{ border: false, size: ButtonSize.S, style: !!this.onStatusInfoAction ? ButtonStyle.Default : ButtonStyle.Inverse  }} buttonText={this.statusInfo} onClick={this.onStatusInfoAction} class={{ RSACPrice: true, RSACPriceAction: !!this.onStatusInfoAction }}>
                    </rentware-button>)
                    :
                    (
                    <span class={"RSACPrice"}>
                    {this.statusInfo}
                    </span>)
                  }
              </div>
            </div>
            <rentware-spacer size="M" />
          </Fragment>
        )}
      </div>
    );
  }
}
